module.exports = __webpack_public_path__ + "img/1.c14d7b4a.png";